import { createContext } from '@gluestack-ui/utils';
export const [RadioProvider, useRadio] = createContext('RadioContext');
